import moment from 'jalali-moment';

const HarvestDate = ({date}: IHarvestDateProps) => {
  const harvestDate =
    date && moment(date, 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD');
  return (
    <div className="flex justify-between mt-7">
      <p className="text-gray-6">تاریخ برداشت محصول:</p>
      <p className="text-gray-6">{harvestDate}</p>
    </div>
  );
};

export default HarvestDate;
